/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import UserForm from './UserForm';
import UserTermsAndConditionsForm from './UserTermsAndConditionsForm';
import EmailValidationInformation from './EmailValidationInformation';
import {searchForFormById} from '../../../selectors/searchForForm';
import mode from '../../../api/mode';
import * as userCreationActions from '../../../actions/userActions';
import * as errorActions from '../../../actions/errorActions';
import * as errorMessages from '../../../constants/errorMessages';
import * as FormName from '../../../constants/formNameConstants';
import '../../../styles/accountCreation/accountCreation.css';


export class UserCreationPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      user: Object.assign({}, this.props.user),
      currentActivePage: 1,
      errors: {},
      activeFields: [],
      userCreationFormIsValid: false,
      formIsValid: false,
      submittingUsers: false
    };

    this.submitUser = this.submitUser.bind(this);
    this.enteringUser = this.enteringUser.bind(this);
    this.userInformationFormValid = this.userInformationFormValid.bind(this);
    this.confirmFormIsValid = this.confirmFormIsValid.bind(this);
    this.changePage = this.changePage.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.googleReCaptchaCallback = this.googleReCaptchaCallback.bind(this);
    this.setActiveFields = this.setActiveFields.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  submitUser(event) {
    event.preventDefault();
    this.setState({submittingUsers: true});
    this.props.userActions.submitUser(this.state.user)
      .then((response) => {
        if (response) {
          this.setState({currentActivePage: 3});
        } else {
          this.setState({currentActivePage: 1});
          throw(new Error(errorMessages.ERROR_USER_CREATION));
        }
      })
      .catch(error => {
        this.setState({submittingUsers: false});
        this.setState({currentActivePage: 1});
        let errors = this.state.errors;
        if(this.props.userCreated.indexOf("email_repeated") != -1){
          errors.email=errorMessages.ERROR_EMAIL_IN_USE;
          this.setState({repeated_email:this.state.user.email});
          this.setState({userCreationFormIsValid:false});
        }
        if(this.props.userCreated.indexOf("username_repeated") != -1){
          errors.username=errorMessages.ERROR_USERNAME_IN_USE;
          this.setState({repeated_username:this.state.user.username});
          this.setState({userCreationFormIsValid:false});
        }
        this.setState({errors:errors});
        throw(error);
      });
    window.scrollTo(0, 0);
  }

  changePage(event) {
    event.preventDefault();
    if (this.state.currentActivePage === 1) {
      this.setState({currentActivePage: 2});
      this.props.errorActions.removeError();
    } else {
      this.setState({currentActivePage: 1});
    }
    window.scrollTo(0, 0);
  }

  enteringUser(event) {
    event.preventDefault();
    const field = event.target.name;
    let user = this.state.user;
    user[field] = event.target.value;
    this.setActiveFields(field);
    this.setState({userCreationFormIsValid: this.userInformationFormValid(this.state.user,
      this.props.requiredFields, this.state.activeFields).formIsValid});
    this.setState({errors: this.userInformationFormValid(this.state.user,
      this.props.requiredFields, this.state.activeFields).errors});
  }

  handleClick(event) {
    const field = event.target.name;
    let user = this.state.user;
    if(user[field] === "1") {
      user[field] = "0";
    } else {
      user[field] = event.target.value;
    }
    this.setState({user: user});
    this.setState({formIsValid: this.confirmFormIsValid()});
  }

  googleReCaptchaCallback(key) {
    let user = this.state.user;
    user.googleCaptcha = key;
    this.setState({user: user});
    this.setState({userCreationFormIsValid: this.userInformationFormValid(this.state.user,
      this.props.requiredFields, this.state.activeFields).formIsValid});
    this.setState({errors: this.userInformationFormValid(this.state.user,
      this.props.requiredFields, this.state.activeFields).errors});
  }

  onBlur(event) {
    event.preventDefault();
    const field = event.target.name;
    this.setActiveFields(field);
    this.setState({userCreationFormIsValid: this.userInformationFormValid(this.state.user,
      this.props.requiredFields, this.state.activeFields).formIsValid});
    this.setState({errors: this.userInformationFormValid(this.state.user,
      this.props.requiredFields, this.state.activeFields).errors});
  }

  setActiveFields(field){
    let activeFields = this.state.activeFields;
    if(activeFields.indexOf(field) == -1){
      activeFields.push(field);
      this.setState({activeFields: activeFields});
    }
  }
  userInformationFormValid(user, requiredFields, activeFields) {
    let formIsValid = true;
    let errors = {};
    requiredFields.map(questionPart=>{
      let fieldName = questionPart.questionPartName;
      let label = questionPart.questionPartLabel;
      if(!user[fieldName]){
        formIsValid = false;
        if(activeFields.indexOf(fieldName) !== -1){
          errors[fieldName] = label + errorMessages.ERROR_NEEDS_VALUE;
        }
      }
    });
    if (user.phoneNumber && (user.phoneNumber.match(/[A-Za-z]/g)
    || user.phoneNumber.match(/\d/g).length !== 10)) {
      formIsValid = false;
      errors.phoneNumber = errorMessages.ERROR_PHONE_NUMBER_NOT_CORRECT;
    }
    if (!user.username) {
      formIsValid = false;
      if(activeFields.indexOf('username') !== -1){
        errors.username = errorMessages.ERROR_NO_USER_NAME;
      }
    }
    if (!user.firstName) {
      formIsValid = false;
      if(activeFields.indexOf('firstName') !== -1){
        errors.firstName = "First Name" + errorMessages.ERROR_NEEDS_VALUE;
      }
    }
    if (user.firstName === null || /^ *$/.test(user.firstName)) {
      formIsValid = false;
      errors.firstName = "First Name" + errorMessages.ERROR_NEEDS_VALUE;
    }
    if (!user.lastName) {
      formIsValid = false;
      if(activeFields.indexOf('lastName') !== -1){
        errors.lastName = "Last Name" + errorMessages.ERROR_NEEDS_VALUE;
      }
    }
    if (user.lastName === null || /^ *$/.test(user.lastName)) {
      formIsValid = false;
      errors.lastName = "Last Name" + errorMessages.ERROR_NEEDS_VALUE;
    }
    if(this.state.repeated_username && this.state.repeated_username == user.username){
      formIsValid = false;
      errors.username = errorMessages.ERROR_USERNAME_IN_USE;
    }
    if(/^\s/.test(user.username)){
      formIsValid = false;
      errors.username = errorMessages.ERROR_USERNAME_BEGIN_SPACE;
    }
    if(/\s$/.test(user.username)){
      formIsValid = false;
      errors.username = errorMessages.ERROR_USERNAME_END_SPACE;
    }

    // let userre = new RegExp('/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/g');
    var userRegExp = new RegExp("^\\w[\\w.]{2,18}\\w$");
    if (user.username && !user.username.match(userRegExp)) {
      formIsValid = false;
      errors.username = errorMessages.ERROR_USERNAME_BAD_CHARACTERS;
    }
    if(/^\s/.test(user.email)){
      formIsValid = false;
      errors.email = errorMessages.ERROR_EMAIL_BEGIN_SPACE;
    }
    if(/\s$/.test(user.email)){
      formIsValid = false;
      errors.email = errorMessages.ERROR_EMAIL_END_SPACE;
    }
    if(this.state.repeated_email && this.state.repeated_email == user.email){
      formIsValid = false;
      errors.email = errorMessages.ERROR_EMAIL_IN_USE;
    }
    //email validation
    let re = new RegExp('[A-Z0-9._%+-]+@[A-Z0-9.-]+[\.][A-Z]{2,}','i');
    if(user.email && user.email.search(re)== -1){
      formIsValid = false;
      errors.email = errorMessages.ERROR_INVALID_EMAIL;
    }
    if (activeFields.indexOf('emailConfirmation') != -1
      && user.email !== user.emailConfirmation){
      formIsValid = false;
      errors.emailConfirmation = errorMessages.ERROR_EMAILS_NOT_MATCHED;
    }
    if (!user.googleCaptcha && this.props.userGoogleCaptcha) {
      formIsValid = false;
    }
    return {formIsValid, errors};

  }

  confirmFormIsValid() {
    let formIsValid = true;
    const user = this.state.user;
    if (user.itaUserCreationAcknowledgement != 1) {
      formIsValid = false;
    }
    return formIsValid;
  }

  render() {
    return (
      <div id="user-creation-page">
        <UserForm
          form={this.props.userCreationForm}
          onSubmit={this.changePage}
          onChange={this.enteringUser}
          onBlur={this.onBlur}
          reCaptchaCallback={this.googleReCaptchaCallback}
          submitStatus={this.state.userCreationFormIsValid}
          errors={this.state.errors}
          pageNumber={1}
          emailConfirmation={this.state.user.emailConfirmation}
          pageActive={this.state.currentActivePage}/>
        <UserTermsAndConditionsForm
          form={this.props.itaTermsAndConditionsForm}
          onSubmit={this.submitUser}
          onBackButtonClick={this.changePage}
          onClick={this.handleClick}
          submitStatus={this.state.formIsValid}
          pageNumber={2}
          pageActive={this.state.currentActivePage}
          user={this.state.user}/>
        <EmailValidationInformation
          pageNumber={3}
          pageActive={this.state.currentActivePage}/>
      </div>
    );
  }
}

UserCreationPage.contextTypes = {
  router: PropTypes.object
};

UserCreationPage.propTypes = {
  userActions: PropTypes.object,
  errorActions: PropTypes.object,
  user: PropTypes.object.isRequired,
  userCreationForm: PropTypes.object.isRequired,
  userCreated:PropTypes.array,
  itaTermsAndConditionsForm: PropTypes.object.isRequired,
  userGoogleCaptcha: PropTypes.bool,
  requiredFields: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  let user = {
    firstName: '',
    lastName: '',
    companyName: '',
    email: '',
    phoneNumber: '',
    itaUserCreationAcknowledgement: '0',
    jobTitle: '',
  };
  let userCreated = state.userCreated;
  let userCreationForm = {};
  let itaTermsAndConditionsForm = {};
  let userGoogleCaptcha = true;
  let requiredFields = [];

  if (state.forms.length > 0) {
    userCreationForm =
      searchForFormById(state.forms, FormName.userCreationFormId);
    itaTermsAndConditionsForm =
      searchForFormById(state.forms, FormName.itaTermsAndConditions);
  }

  //if we are in local environment or staging, lets not require google captcha

  const currentLocation = window ? window.location.host : null;
  if(!mode.prod
    && currentLocation !== 'test.osha.gov'
    && currentLocation !== 'www.osha.gov') {
    userGoogleCaptcha = false;
  }

  if(userCreationForm && userCreationForm.formQuestions){
    requiredFields = [].concat.apply([], userCreationForm.formQuestions.map(question=>{
      let required = question.questionParts.map(questionPart=>{
        if(questionPart.questionPartRequired =="1"){
          return questionPart;
        }
      }).filter(questionPart=>{return questionPart;});
      return required;
    }));
  }

  return {
    user,
    userCreated,
    userCreationForm,
    itaTermsAndConditionsForm,
    userGoogleCaptcha,
    requiredFields
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userActions: bindActionCreators(userCreationActions, dispatch),
    errorActions: bindActionCreators(errorActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserCreationPage);



/** WEBPACK FOOTER **
 ** ./src/components/account/createAccount/UserCreationPage.js
 **/